module.exports = __webpack_public_path__ + "img/2_129.81eea6ff.png";